import { isFile } from "@/utils/is/file"

export type FindexFile = {
  item: File
  base64?: string
}

export const isFindexFile = (x: any): x is FindexFile => {
  if (!x) return false
  if (isFile(x.item)) return true;
  return  !!(x.item && x.base64)
}
